import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import { MainScrappingWrapper } from './scrapping-forms/MainScrapping'


const ScrappingPage = () => {
  return (
    <Routes>
     
      <Route index element={
            <>
              <PageTitle >Add your website</PageTitle>
              <MainScrappingWrapper />
            </>
          } />
    </Routes>
  )
}



export default ScrappingPage;
